// OneDrive:IgnoreCodeCoverage

import Locale from '../locale/Locale';

export * from '@ms/utilities-strings/lib/index';

export function getLocaleNumberString(number: Number, options?: Intl.NumberFormatOptions, defaultValue?: string): string {
    let result = defaultValue;
    const lang = Locale.language;

    if (number) {
        try {
            result = number.toLocaleString(lang, options);
        } catch (e) {
            // in case 'lang' is invalid for browser, fallback to let browser use own logic for determining language
            result = number.toLocaleString([], options);
        }
    }

    return result;
}
